import { useState, useEffect, useCallback } from 'react';
import { tobaccoProducts } from 'services';
import { skeletonFactory, useHandleRequest } from 'shared';

const productDummy = skeletonFactory.tobaccoProduct();

export function useTobaccoProduct(id) {
  const [productData, setProductData] = useState(id ? productDummy : {});
  const { request, errorInfo, setErrorInfo } = useHandleRequest();

  useEffect(() => {
    async function getData() {
      await request(async () => {
        const response = await tobaccoProducts.getById(id);
        if (response) {
          setProductData(response.data || {});
        }
      }, false);
    }
    id && getData();
  }, [request, id]);

  const updateProduct = useCallback(
    async product => {
      await request(async () => {
        setProductData(product);
        await tobaccoProducts.update(id, product);
      });
    },
    [request, id]
  );

  const createProduct = useCallback(
    async product => {
      await request(async () => {
        setProductData(product);
        await tobaccoProducts.create(product);
      });
    },
    [request]
  );

  return {
    product: productData,
    errorInfo,
    setErrorInfo,
    setProductData,
    createProduct,
    updateProduct
  };
}
